import Title from './title/index.vue'
import Notice from './notice/index.vue'
import Picture from './picture/index.vue'
import Rich from './rich/index.vue'
import Blank from './blank/index.vue'
import Nav from './nav/index.vue'
import Goods from './goods/index.vue'
import Suspend from './suspend/index.vue'
import Modal from './modal/index.vue'
import Group from './group/index.vue'
import Coupon from './coupon/index.vue'
import Leave from './leave/index.vue'
import Album from './album/index.vue'
import Course from './course/index.vue'
import Video from './video/index.vue'
import Ebook from './ebook/index.vue'
import CountDown from './countDown/index.vue'
import Rule from './rule/index.vue'
import Audio from './audio/index.vue'
import Backtop from './backtop/index.vue'
import Button from './button/index.vue'
import TextCarousel from './textCarousel/index.vue'
import PictureBook from './pictureBook/index.vue'
import Lift from './lift/index.vue'
import Collocation from './collocation/index.vue'

export default {
  Title,
  Notice,
  Picture,
  Rich,
  Blank,
  Nav,
  Goods,
  Suspend,
  Modal,
  Group,
  Coupon,
  Leave,
  Album,
  Video,
  Ebook,
  CountDown,
  Rule,
  Audio,
  Backtop,
  Button,
  TextCarousel,
  PictureBook,
  Lift,
  Course,
  Collocation,
}
